import React, { FC } from "react";

import { useInstagram } from "@hooks/useInstagram";

import type { ComponentProps, FromSanityGraphQL } from "@ts/components";
import type { SectionInstagram } from "@ts/sanity";

import { ExpandedAsset } from "@bared/ui";

export type InstagramInputProps = ComponentProps &
  FromSanityGraphQL<SectionInstagram>;

export type InstagramOutputProps = InstagramInputProps & {
  contents: [
    {
      postImage: ExpandedAsset;
      productHandle?: string;
      userName: string;
    },
  ];
  handleClick: () => void;
};

export const withInstagram =
  (Component: FC<InstagramOutputProps>) =>
  ({
    name = "Instagram",
    analytics,
    usernameFilter,
    ...rest
  }: InstagramInputProps) => {
    const { items } = useInstagram(usernameFilter);

    Component.displayName = name;
    return <Component {...rest} contents={items} />;
  };
